import { apiUserFetch } from '..';
import type {
  GammaRoleRequestListResponse,
  RejectGammaRoleRequestBody,
  RoleRequestCreatedResponse,
  RoleRequestInput,
  RoleRequestStatus,
} from './types';

export type GammaRoleRequestsClient = {
  create: (_input: RoleRequestInput) => Promise<RoleRequestCreatedResponse>;
  list: (_status?: RoleRequestStatus) => Promise<GammaRoleRequestListResponse>;
  approve: (_requestId: string) => Promise<void>;
  reject: (_requestId: string, _body: RejectGammaRoleRequestBody) => Promise<void>;
};

export const gammaRoleRequestsClient: GammaRoleRequestsClient = {
  create: (body) =>
    apiUserFetch<RoleRequestCreatedResponse>('/gamma/role-requests', { method: 'POST', body }),
  list: (status) =>
    apiUserFetch<GammaRoleRequestListResponse>('/gamma/role-requests', {
      params: { status },
    }),

  approve: (requestId) =>
    apiUserFetch<void>(`/gamma/role-requests/${encodeURIComponent(requestId)}/approve`, {
      method: 'POST',
    }),

  reject: (requestId, body) =>
    apiUserFetch<void>(`/gamma/role-requests/${encodeURIComponent(requestId)}/reject`, {
      method: 'POST',
      body,
    }),
};
